import React from 'react';
import styled from 'styled-components';
import Icon from 'components/ui/Icon';

import { getTranslatedString } from 'helpers/i18n';

const StyledContainer = styled.div`
  text-align: center;
  padding: 24px 10px;
`;

export const StyledIcon = styled(Icon)`
  font-size: 18px;
`;

const StyledText = styled.div``;

const EmptySelectState = ({ optionTitle }) => {
  return (
    <StyledContainer>
      <StyledIcon type="search" />
      <StyledText>
        {getTranslatedString('landlordPortal.filterAndSelect.noOptionsFound', {
          optionTitle: optionTitle,
        })}
      </StyledText>
    </StyledContainer>
  );
};

export default EmptySelectState;
